import type {
  SessionPollingController,
  UseSessionPollingInput,
} from "./session-polling.types";
import { useSessionPollingController } from "./use-session-polling-controller";
import { useSessionPollingPollers } from "./use-session-polling-pollers";

export function useSessionPolling(
  input: UseSessionPollingInput,
): SessionPollingController {
  const pollers = useSessionPollingPollers(input);
  return useSessionPollingController({ pollers });
}
